/**
 * Enum that specifies what type of a resource node this is. Used mostly for simplify UI work and not having to look/cast specific classes.
 */
export enum EResourceNodeType {
  Node,
  FrackingSatellite,
  FrackingCore,
  Geyser,
}
